document.addEventListener("readystatechange", (e) => {
  if(document.readyState === "complete") {

    //If user clicks certain Header/Footer links from Yext store locator
    //They get redirected back to the Shopify side with URL Params
    const urlParameters = new URLSearchParams(window.location.search);

    //If user clicks country selector
    if(urlParameters.has("show-country-selector")) {
      const windowWidth = window.innerWidth;

      if(windowWidth >= 990) {
        const countrySelector = document.querySelector(".header__country-and-locator button");
              countrySelector?.click();
      }
      else {
        const countrySelector = document.querySelector(".email-signup__links--mobile .footer__country-and-locator button");
              countrySelector?.click();
      }
    }
    //If user clicks cookie prefs
    else if(urlParameters.has("show-cookie-prefs")) {
      const cookieLink = document.querySelector(".footer__copyright-menu__link[href='#trustarc_cookie_settings']");
            cookieLink?.click();
    }
  }
});